import { CheckCircleOutlined, InfoCircleOutlined } from "@/icons"

import styles from "./DetectionStateIcon.module.scss"

export const DetectionStateIcon = (props: { isSuccess?: boolean }) => {
  if (props.isSuccess) return <CheckCircleOutlined className={styles.success} />

  return <InfoCircleOutlined className={styles.incident} />
}
